import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e3fa6d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-grid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-shrink":"1"} }, "Service Name", -1))
const _hoisted_3 = {
  fill: "none",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  stroke: "#E5E5E5",
  d: "M3 9l4-4l4 4M7 5v14"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-shrink":"1"} }, "Price / Unit", -1))
const _hoisted_6 = {
  fill: "none",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  stroke: "#E5E5E5",
  d: "M3 9l4-4l4 4M7 5v14"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service actions head" }, " Action ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-divider" }, null, -1))
const _hoisted_10 = {
  class: "service name",
  id: "nama-layanan"
}
const _hoisted_11 = {
  class: "service price",
  id: "harga-layanan"
}
const _hoisted_12 = { class: "service actions" }
const _hoisted_13 = { class: "with-icon clear" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "h" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]

import {getCurrentInstance, ref} from 'vue';
import Pagination from '@/components/Pagination.vue';
import Modal from "@/components/Modal.vue";
import axios from 'axios'
import store from "@/store/index.js"

import {InformationOutline, PencilOutline, PlusBox, TrashCanOutline, DotsVertical} from "mdue";
import {NTooltip, NPopover} from 'naive-ui'
import json from "@/mock.json";
import {useRouter, useRoute} from "vue-router";
import {Service} from "@/types/Service";

interface LooseObject {
  [key: string]: any
}


// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceList',
  props: {
    editable: { type: Boolean },
    url: null
  },
  setup(__props: any) {

const props = __props as {
  editable?: boolean,
  url?: string
}



// Exported variables
// Data
const services = ref<Service[] | null>();
const totalServices = ref(0);

// Message Naive UI
const app = getCurrentInstance()
const message = app!.appContext.config.globalProperties.message

// Modal stuffs
const modal = ref([])
const currentModal = ref(0)

// Pagination stuffs
const currentPage = ref(1)

// Misc
const router = useRouter();

// Sort
let sort = ref("id")
let order = ref("asc")


// Setup logic
getServices(currentPage.value)


// Functions
async function getServices(page: any) {

  const query: LooseObject = {}
  currentPage.value = page;

  if (sort.value !== '') {
    if (sort.value === 'id' || sort.value === 'service_name' || sort.value === 'price') {
      page = `${page}&ordering=${order.value === 'desc' ? '-' : ''}${sort.value}`
      query.sortby = sort
      query.order = order
    }
  }

  if (currentPage.value > 1)
    query.page = currentPage.value


  await axios.get(props.url + `?page=${page}`)
      .then(response => {
        services.value = response.data.results
        totalServices.value = response.data.count
      })
      .catch(error => console.log(error))


}

function submit() {
  router.push('/service/add')
}


function edit(id: number) {
  router.push('/service/edit/' + id)
}

function hapus(id: number) {
  axios.delete(`/api/service/${id}`)
      .then(response => {
        message.success("Service is successfully removed!", {showIcon: true, closable: true})
        getServices(currentPage.value);
        (modal.value as any)[currentModal.value].showModal = false;
      })
      .catch((error) => {
        message.error("A problem is occurred when removing service. Please try again", {showIcon: true, closable: true})
        console.log(error)
      })
}

function batal(i: number) {
  (modal.value as any)[i].showModal = false
}

function onPageChange(page: number) {
  currentPage.value = page;
  getServices(page);
}

function onSortFilter(value: string) {
  sort.value = value
  order.value = (order.value === 'asc') ? 'desc' : 'asc'
  currentPage.value = 1;
  getServices(1);
}

function formatMoney(money: number, namaUang: string, unit: string) {
  let formattedMoney = money.toLocaleString()
  return namaUang + " " + formattedMoney + " / " + unit
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", {
        class: "service",
        id: "tambah",
        onClick: submit
      }, [
        _createVNode(_unref(PlusBox), { style: {"font-size":"32px"} }),
        _createTextVNode(" Add new service ")
      ], 512), [
        [_vShow, __props.editable]
      ]),
      _createVNode(_unref(NTooltip), null, {
        trigger: _withCtx(() => [
          _createElementVNode("div", {
            class: "service name head",
            id: "nama-layanan-head",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onSortFilter('service_name')))
          }, [
            _hoisted_2,
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass({ flip : _unref(sort) == 'service_name' && _unref(order) == 'desc'}),
              height: "24",
              width: "24",
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("g", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("path", {
                  class: _normalizeClass({ sort : _unref(sort) == 'service_name'}),
                  stroke: "#E5E5E5",
                  d: "M21 15l-4 4l-4-4m4 4V5"
                }, null, 2)
              ])
            ], 2))
          ])
        ]),
        default: _withCtx(() => [
          _createTextVNode(" Sort " + _toDisplayString(_unref(order) == 'desc' ? "Descending" : "Ascending"), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(NTooltip), null, {
        trigger: _withCtx(() => [
          _createElementVNode("div", {
            class: "service price head",
            id: "harga-layanan-head",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onSortFilter('price')))
          }, [
            _hoisted_5,
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass({ flip : _unref(sort) == 'price' && _unref(order) == 'desc'}),
              height: "24",
              width: "24",
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("g", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("path", {
                  class: _normalizeClass({ sort : _unref(sort) == 'price'}),
                  stroke: "#E5E5E5",
                  d: "M21 15l-4 4l-4-4m4 4V5"
                }, null, 2)
              ])
            ], 2))
          ])
        ]),
        default: _withCtx(() => [
          _createTextVNode(" Sort " + _toDisplayString(_unref(order) == 'desc' ? "Descending" : "Ascending"), 1)
        ]),
        _: 1
      }),
      _hoisted_8,
      _hoisted_9,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(service.service_name), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(formatMoney(service.price, service.currency.currency_code, service.unit)), 1),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(Modal, null, {
              trigger: _withCtx(() => [
                _createVNode(_unref(NTooltip), null, {
                  trigger: _withCtx(() => [
                    _createElementVNode("button", _hoisted_13, [
                      _createVNode(_unref(InformationOutline), { style: {"font-size":"24px"} })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" View Details ")
                  ]),
                  _: 1
                })
              ]),
              content: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(service.service_name), 1),
                _createElementVNode("span", null, _toDisplayString(formatMoney(service.price, service.currency.currency_code, service.unit)), 1),
                _createElementVNode("div", {
                  innerHTML: service.description
                }, null, 8, _hoisted_14)
              ]),
              _: 2
            }, 1024),
            _createVNode(_unref(NTooltip), null, {
              trigger: _withCtx(() => [
                _withDirectives(_createElementVNode("button", {
                  class: "edit with-icon clear",
                  id: "edit",
                  onClick: ($event: any) => (edit(service.id))
                }, [
                  _createVNode(_unref(PencilOutline), { style: {"font-size":"24px"} })
                ], 8, _hoisted_15), [
                  [_vShow, __props.editable]
                ])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Edit ")
              ]),
              _: 2
            }, 1024),
            _createVNode(Modal, {
              ref_for: true,
              ref: el => modal.value[i] = el
            }, {
              trigger: _withCtx(() => [
                _createVNode(_unref(NTooltip), null, {
                  trigger: _withCtx(() => [
                    _withDirectives(_createElementVNode("button", {
                      class: "hapus with-icon clear",
                      id: "delete",
                      onClick: () => {_ctx.currentModalI = i}
                    }, [
                      _createVNode(_unref(TrashCanOutline), { style: {"font-size":"24px"} })
                    ], 8, _hoisted_16), [
                      [_vShow, __props.editable]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Remove ")
                  ]),
                  _: 2
                }, 1024)
              ]),
              content: _withCtx(() => [
                _createTextVNode(" Are you sure you want to remove layanan \"" + _toDisplayString(service.service_name) + "\"? ", 1),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (batal(i))
                  }, " Cancel ", 8, _hoisted_18),
                  _createElementVNode("button", {
                    class: "hapus accent",
                    id: "confirm",
                    onClick: ($event: any) => (hapus(service.id))
                  }, " Remove ", 8, _hoisted_19)
                ])
              ]),
              _: 2
            }, 1536)
          ])
        ], 64))
      }), 128))
    ]),
    _createVNode(Pagination, {
      maxVisibleButtons: 5,
      totalPages: Math.ceil(totalServices.value/10) || 1,
      perPage: 10,
      currentPage: currentPage.value,
      onPagechanged: onPageChange
    }, null, 8, ["totalPages", "currentPage"])
  ], 64))
}
}

})